import * as React from 'react';
import { AddonContext } from '../generics';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var positionsToDisplay = function positionsToDisplay(positions, current) {
  return positions.map(function (position) {
    return position === current ? 'block' : 'none';
  });
};

var ProductTableAddonResponsive = {
  defaultArguments: {
    positions: ['body', 'header']
  },
  body: function body(_ref) {
    var children = _ref.children,
        bodyOrder = _ref.bodyOrder,
        positions = _ref.positions;

    if (!positions.includes('body')) {
      return null;
    }

    return _jsx(AddonContext.Provider, {
      value: {
        inAddon: 'body-responsive',
        order: bodyOrder,
        extraRules: {
          display: positionsToDisplay(positions, 'body'),
          marginBottom: 0
        }
      },
      children: children
    });
  },
  grid: function grid(_ref2) {
    var children = _ref2.children,
        gridOrder = _ref2.gridOrder,
        positions = _ref2.positions;

    if (positions[0] === 'grid') {
      console.error('Using the grid position on mobile will cause a gap on desktop - use the body position instead');
    }

    if (!positions.includes('grid')) {
      return null;
    }

    return _jsx(AddonContext.Provider, {
      value: {
        inAddon: 'grid-responsive',
        order: gridOrder,
        extraRules: {
          display: positionsToDisplay(positions, 'grid'),
          marginBottom: [0, 'sm']
        }
      },
      children: children
    });
  },
  header: function header(_ref3) {
    var children = _ref3.children,
        headerOrder = _ref3.headerOrder,
        positions = _ref3.positions;

    if (!positions.includes('header')) {
      return null;
    }

    return _jsx(AddonContext.Provider, {
      value: {
        inAddon: 'header-responsive',
        order: headerOrder,
        extraRules: {
          display: positionsToDisplay(positions, 'header')
        }
      },
      children: children
    });
  }
};
export default ProductTableAddonResponsive;
//# sourceMappingURL=addon-responsive.js.map